/*
  MAMU · Páginas v3 — JS mínimo y opcional (sin librerías).
  Sin este archivo todo se ve completo y estático; solo se pierde el cambio de foto.

  1. Escena de telas  [data-mamu-escena]  (sección mamu-telas-muestrario)
     Las muestras llevan [data-mamu-tela] y, si tienen foto de sala, data-sala="<id de figura>".
     Al pasar el cursor, enfocar o tocar una muestra con sala, se muestra su figura y la etiqueta.
  2. Pasos de Nosotros  [data-mamu-pasos]  (sección mamu-pagina-pasos)
     El panel fijo cambia de foto según el paso que cruza el centro de la pantalla.
  3. Barra de compra fija: marca <html data-mamu-dock> cuando la barra inferior está visible para
     dar espacio al pie de la ficha (el CSS usa ese atributo).
  4. Ficha: las pills y los botones Guardar / Comparar suben a la esquina de la foto.
  5. Telas: mini vista flotante con la foto de la tela elegida y, si el producto tiene mamu.telas_fotos,
     la foto principal de la galería cambia por el producto en esa tela.
*/


function initEscena(root) {
  if (root.dataset.mamuReady) return;
  root.dataset.mamuReady = 'true';

  const figuras = Array.from(root.querySelectorAll('[data-escena-fig]'));
  const muestras = Array.from(root.querySelectorAll('[data-mamu-tela]'));
  if (!figuras.length || !muestras.length) return;

  const porDefecto = figuras.find((f) => f.hasAttribute('data-escena-base')) ?? figuras[0];

  const mostrar = (id) => {
    const destino = figuras.find((f) => f.id === id) ?? porDefecto;
    for (const fig of figuras) fig.classList.toggle('is-activa', fig === destino);
    for (const m of muestras) m.classList.toggle('is-activa', m.dataset.sala === destino.id);
  };

  for (const muestra of muestras) {
    const sala = muestra.dataset.sala;
    if (!sala) continue;
    muestra.addEventListener('pointerenter', (e) => {
      if (e.pointerType === 'mouse') mostrar(sala);
    });
    muestra.addEventListener('focus', () => mostrar(sala));
    muestra.addEventListener('click', () => mostrar(sala));
  }
  root.addEventListener('pointerleave', (e) => {
    if (e.pointerType === 'mouse') mostrar(porDefecto.id);
  });
  mostrar(porDefecto.id);
}

function initPasos(root) {
  if (root.dataset.mamuReady) return;
  root.dataset.mamuReady = 'true';

  const panel = root.querySelector('[data-pasos-panel]');
  const pasos = Array.from(root.querySelectorAll('[data-paso]'));
  if (!panel || !pasos.length || !('IntersectionObserver' in window)) return;

  root.classList.add('is-js');
  const activar = (n) => {
    panel.dataset.activo = String(n);
    for (const p of pasos) p.classList.toggle('is-activo', Number(p.dataset.paso) === n);
  };
  activar(1);

  const io = new IntersectionObserver(
    (entradas) => {
      for (const e of entradas) {
        if (e.isIntersecting) activar(Number(e.target.dataset.paso));
      }
    },
    { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
  );
  for (const p of pasos) io.observe(p);
}

function initDock() {
  const bar = document.querySelector('.sticky-add-to-cart__bar');
  if (!bar) return;
  const marcar = () => {
    document.documentElement.toggleAttribute('data-mamu-dock', bar.getAttribute('data-stuck') === 'true');
  };
  new MutationObserver(marcar).observe(bar, { attributes: true, attributeFilter: ['data-stuck'] });
  marcar();
}

/* 4. Ficha móvil: pills, Guardar y Comparar suben a la foto (arriba izquierda / derecha) */
function initSobreFoto() {
  const media = document.querySelector('.product-information__media');
  if (!media || media.querySelector('.mamu-p-sobre')) return;
  const pills = document.querySelector('[data-mamu-sobre-izq]');
  const botones = [...document.querySelectorAll('[data-mamu-acciones] .mamu-p-acc__fav, [data-mamu-acciones] .mamu-p-acc__comparar')];
  if (!pills && !botones.length) return;

  const capa = document.createElement('div');
  capa.className = 'mamu-p-sobre';
  const izq = document.createElement('div');
  izq.className = 'mamu-p-sobre__izq';
  const der = document.createElement('div');
  der.className = 'mamu-p-sobre__der';
  if (pills) izq.append(pills);
  der.append(...botones);
  capa.append(izq, der);
  media.append(capa);
  media.classList.add('mamu-p-media');
}

/* 5. Telas: al elegir una, mini vista flotante con la foto de la tela y su nombre (sticky arriba)
      y, si el producto tiene mamu.telas_fotos, la foto principal de la galería pasa a ser el producto en esa tela */
let telaTimer = 0;

function srcAncho(url, w) {
  return url + (url.includes('?') ? '&' : '?') + 'width=' + w;
}

function fotoGaleria(origen, url) {
  const galeria = origen.closest('.shopify-section')?.querySelector('media-gallery') ?? document.querySelector('media-gallery');
  if (!galeria) return false;
  const imgs = [
    galeria.querySelector('slideshow-slide img.product-media__image'),
    galeria.querySelector('zoom-dialog [ref="media[]"] img.product-media__image'),
  ].filter(Boolean);
  if (!imgs.length) return false;
  for (const img of imgs) {
    if (!img.dataset.mamuOrigSrc) {
      img.dataset.mamuOrigSrc = img.getAttribute('src') ?? '';
      img.dataset.mamuOrigSrcset = img.getAttribute('srcset') ?? '';
    }
    if (url) {
      img.setAttribute('src', srcAncho(url, 1600));
      img.setAttribute('srcset', [600, 900, 1200, 1600, 2000].map((w) => `${srcAncho(url, w)} ${w}w`).join(', '));
    } else {
      img.setAttribute('src', img.dataset.mamuOrigSrc);
      if (img.dataset.mamuOrigSrcset) img.setAttribute('srcset', img.dataset.mamuOrigSrcset);
      else img.removeAttribute('srcset');
    }
  }
  // vuelve a la primera foto para que se vea el cambio
  try { galeria.slideshow?.select?.(0); } catch (_) { /* sin slideshow */ }
  return true;
}

function initTelaPrev() {
  if (document.documentElement.dataset.mamuTelaPrev) return;
  document.documentElement.dataset.mamuTelaPrev = 'true';
  document.addEventListener('change', (e) => {
    const input = e.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('[data-mamu-tela-input]') || !input.checked) return;
    const prev = input.closest('[data-mamu-pdp-telas]')?.querySelector('[data-mamu-tela-prev]');
    const label = input.closest('.mamu-p-tela');
    const fotoProducto = label?.dataset.fotoProducto || '';
    // foto del producto en esa tela -> galería; sin foto, la galería vuelve a como estaba
    const enGaleria = fotoGaleria(input, fotoProducto);
    const foto = label?.dataset.foto || (!enGaleria ? fotoProducto : '');
    if (!prev || !foto) return;
    const img = prev.querySelector('img');
    const nombre = prev.querySelector('[data-mamu-tela-prev-name]');
    if (img) img.src = foto;
    if (nombre) nombre.textContent = input.dataset.name ?? '';
    // justo debajo de la cabecera pegada
    const barra = document.querySelector('.mamu-cab__bar');
    const top = barra ? Math.max(0, Math.round(barra.getBoundingClientRect().bottom)) : 0;
    prev.style.setProperty('--mamu-prev-top', `${top + 8}px`);
    prev.hidden = false;
    requestAnimationFrame(() => prev.classList.add('is-on'));
    clearTimeout(telaTimer);
    telaTimer = window.setTimeout(() => {
      prev.classList.remove('is-on');
      window.setTimeout(() => { prev.hidden = true; }, 300);
    }, 4000);
  });
}

function init() {
  initSobreFoto();
  initTelaPrev();
  for (const el of document.querySelectorAll('[data-mamu-escena]')) initEscena(el);
  for (const el of document.querySelectorAll('[data-mamu-pasos]')) initPasos(el);
  initDock();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
// El editor de temas vuelve a pintar las secciones al editarlas.
document.addEventListener('shopify:section:load', init);
